// rnd 서버(Python FastAPI) 클라이언트 — 채팅 로그 적재 + 라이브 분석.
// 적재는 rnd가 소유(구 relay에서 이전). 신원은 오버레이가 owner_id/pet_id 직접 전달.
const RND = process.env.VUE_APP_RND_HOST_URL;

// 일반 플러시(주기/크기 도달). payload = { owner_id, pet_id, events }
export async function flushChatLog(payload) {
  if (!payload || !payload.events || !payload.events.length) return true;
  try {
    const res = await fetch(`${RND}/chat-log`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true, // 탭 이동 직전 호출도 최대한 살림
    });
    return res.ok;
  } catch (e) {
    return false;
  }
}

// 언로드(탭 닫기/이동) 시 잔여 플러시. sendBeacon은 페이지가 사라져도 전송 보장.
export function beaconChatLog(payload) {
  if (!payload || !payload.events || !payload.events.length || !navigator.sendBeacon) return false;
  try {
    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    return navigator.sendBeacon(`${RND}/chat-log`, blob);
  } catch (e) {
    return false;
  }
}

// 처음부터 분석 — 클라가 넘긴 메시지(로드 이후 누적)만 → 렌즈. 세션 전체는 analyzeSession.
export async function analyze(messages, top = 15) {
  if (!messages || !messages.length) return null;
  try {
    const res = await fetch(`${RND}/analyze/new-start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages, top }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    return null;
  }
}

// 세션 라이브 분석 — 서버가 오늘 jsonl 전체를 읽어 렌즈 A·C·D. 생성과 동일 소스(리프레시해도 누적 유지).
export async function analyzeSession({ ownerId, channel, platform, top = 15 } = {}) {
  if (!ownerId || !channel) return null;
  try {
    const res = await fetch(`${RND}/analyze/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ owner_id: ownerId, channel, platform, top }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) {
    return null;
  }
}

// 마지막 세션룰 조회는 DB(공개 RPC)로 이관 → SupabaseApi.ReactionKeywordSessionRule.fetchLatest.
//  (rnd /rules/session/last + session_cache는 아직 서버에 남아있으나 클라는 미사용)

// SESSION 키워드 룰 생성 — 서버가 세션 jsonl을 읽어 렌즈→후보→카탈로그→LLM.
// 신원(owner/channel/platform)만 넘김. date 생략 = 서버가 오늘(KST). 반환: 룰 배열 | null.
export async function generateSessionRules({ ownerId, channel, platform } = {}) {
  if (!ownerId || !channel) return null;
  try {
    const res = await fetch(`${RND}/rules/generate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ owner_id: ownerId, channel, platform, layer: "SESSION" }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.rules || [];
  } catch (e) {
    return null;
  }
}
